export default "__VITE_ASSET__JcFy99WV__"